import React from 'react';

const AccountProfile = props => {
    return (
        <div>Account profile</div>
    );
};

export default AccountProfile;
